import { Icon } from '@blueprintjs/core';
import { BActionIcon } from '@components/BActionIcon/BActionIcon';
import { Center } from '@mantine/core';
import {
  hasAction,
  MASS_EDIT_SEND_TYPE,
  MASS_EDIT_STATE_TYPE,
} from '@store/machines/massEdit';
import { UseFormReturn } from 'react-hook-form';
import { memo } from 'react';
import { MassEditContext } from '@store/machines/massEdit.schema';
import { SetState } from '@pages/Organization/utils/onOrgNameSubmit';
import {
  AddMoreButton,
  ChangesText,
  Row,
  SaveDiv,
  InputGrid,
  P200,
} from './styles';
import { IFormDataOnboardingModal } from '../OnBoardingModal';
import {
  HeaderBar,
  HeadingTop,
  Header,
  AddMoreList,
} from '../OnBoardingModal.styles';
import { GlobalViewValue, ViewValues, GlobalInput } from '../types';
import { getInputs } from '../helpers/getInputs';
import { IHeadingChildren } from '../helpers/HeadingsCalc';
import { RightSideProps } from './RightSide';

const CENTERSTYLE = { height: 40, alignSelf: 'end', justifyContent: 'left' };

interface Props {
  isDirty: boolean;
  setFormV: SetState<IFormDataOnboardingModal>;
  globalFormV: GlobalInput;
  setGlobalFormV: SetState<GlobalInput>;
  viewForm: UseFormReturn<ViewValues>;
  globalViewForm: UseFormReturn<GlobalViewValue>;
  activePage: IHeadingChildren;
  isOnboarding: boolean;
  send: MASS_EDIT_SEND_TYPE;
  actionQueue: MassEditContext['actionQueue'];
  matches: MASS_EDIT_STATE_TYPE['matches'];
  onSubmit: VoidFunction;
  mode: RightSideProps['mode'];
  customFields: RightSideProps['customFields'];
  equipmentsCount: number;
}
function RightHeading(props: Props) {
  const {
    isDirty,
    setFormV,
    activePage,
    isOnboarding,
    actionQueue,
    matches,
    send,
    onSubmit,
    globalViewForm,
    viewForm,
    mode,
    customFields,
    globalFormV,
    setGlobalFormV,
    equipmentsCount,
  } = props;

  const inputs = getInputs({
    setFormV,
    activePage,
    viewForm,
    mode,
    equipmentsCount,
    customFieldsQuery: customFields,
    setGlobalFormV,
    config: {
      globalFormV,
      kind: 'GROUP',
      globalViewForm,
    },
  });
  // To avoid flicker in ui between.
  const isSavingOrCheckingQueue =
    matches('open.editing.saving') ||
    matches('open.editing.checking for pending save action');

  return (
    <HeadingTop>
      <HeaderBar>
        <Header>{activePage.name}</Header>
        <AddMoreList>
          <Row>
            <AddMoreButton
              onClick={() => {
                if (matches('open.closing.prompt')) return;
                send({
                  type: 'TERMINATE',
                  reason: 'ADD-MORE',
                  isSaving: matches('open.editing.saving'),
                });
              }}
              hidden={isOnboarding}
              data-enable-new-icon
            >
              <Icon icon="plus" color="#1371fe" />
              Add More Assets
            </AddMoreButton>
            <SaveDiv
              disabled={!isDirty}
              onClick={onSubmit}
              data-enable-new-icon
            >
              <Icon
                icon="floppy-disk"
                color={isDirty ? '#1371FE' : '#8F95B2'}
              />
              Save
            </SaveDiv>
            <ChangesText>{getChangeText()}</ChangesText>
          </Row>
          <BActionIcon
            icon="cross"
            onClick={() => {
              if (matches('open.closing.prompt')) return;
              send({
                type: 'TERMINATE',
                reason: null,
                isSaving: matches('open.editing.saving'),
              });
            }}
          />
        </AddMoreList>
      </HeaderBar>
      <InputGrid>
        <Center sx={CENTERSTYLE}>
          <P200>Group Edit</P200>
        </Center>
        {inputs}
      </InputGrid>
    </HeadingTop>
  );

  function getChangeText() {
    if (isSavingOrCheckingQueue) {
      if (isDirty && !hasAction(actionQueue, 'SAVE')) {
        return "Some changes aren't being saved...";
      }
      return 'Saving...';
    }
    if (isDirty) return 'You have unsaved changes';
    return 'No changes to save';
  }
}

export type { Props as RightHeadingProps };
export default memo(RightHeading);
